import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="Footer">
      Made by <a href="https://github.com/karina4840" target='_blank'>karina i.</a>
    </footer>
  );
}

export default Footer;

